export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    route: 'dashboard-godigital',
    tagVariant: 'light-warning',
  },
]
